export default (function (_ref) {
  var colors = _ref.colors;
  return {
    container: {
      color: colors.grayDarker,
      backgroundColor: colors.secondary,
      '&:after': {
        borderColor: "transparent transparent transparent ".concat(colors.secondary)
      }
    },
    '&:before': {
      borderColor: "transparent transparent transparent ".concat(colors.background)
    }
  };
});